import Link from './Link';
import Interaction from './Interaction';

const EntityButtons = {
  Interaction,
  Link,
};

export default EntityButtons;
